import { USER_STATUS } from 'constants/status';
import { USER_TYPE } from 'constants/userTypes';

const notEditableStatuses: string[] = [
  USER_STATUS.active,
  USER_STATUS.accountProcessing,
  USER_STATUS.accountCreationFailed,
];

const independentIraEditableStatuses: string[] = [
  USER_STATUS.draft,
  USER_STATUS.invited,
  USER_STATUS.accepted,
  USER_STATUS.kycNotStarted,
];

export const canEditProfile = (profileStatus: string, userType?: string): boolean =>
  userType === USER_TYPE.independentIra
    ? independentIraEditableStatuses.includes(profileStatus)
    : !notEditableStatuses.includes(profileStatus);
